
import { NgModule } from '@angular/core';

import { DocTypeEditProvider } from './doctype-edit.provider';
import { DocTypeListProvider } from './doctype-list.provider';

export * from './doctype-edit.provider';
export * from './doctype-list.provider';

export {
  DocTypeListProvider,
  DocTypeEditProvider
};

@NgModule({
  declarations: [

  ],
  imports: [
  ],
  exports: [

  ],
  providers: [
    DocTypeEditProvider,
    DocTypeListProvider
  ]
})
export class DocTypeBackendModule { }
